import React, { useEffect, useRef, useState } from 'react';
import '../TermGlossary/TermsGlossary.scss';
import { useDictionaryStore } from '../../../hooks/useDictionaryStore';
import axios from 'axios';
import { getDictSources } from '../../common/utils';
import { Overlay, Popover } from 'react-bootstrap';
import { HtmlCustom } from '../../common/MandalaMarkup';
import {
    BsBlockquoteLeft,
    FaExternalLinkAlt,
    FaRegBookmark,
    FaRegClipboard,
} from 'react-icons/all';

export default function TermDictionaryChooser({ lang = 'new' }) {
    const {
        dictionaries,
        dictInfo,
        setDictionaries,
        getSelectedDicts,
        setSelectedDicts,
        getDictsByLang,
        addDictionary,
        removeDictionary,
    } = useDictionaryStore();
    const engDicts = [
        'hopkins',
        'martin',
        'rangjung',
        'waldo',
        'valby',
        'barron',
        'higgins',
    ];

    // Function to select a groupd of dictionaries based on a link click
    const selectDicts = (scope) => {
        const dictValues = Array.from(
            document.querySelectorAll('#dictionary-form input.dictionary')
        ).map((input) => input.value);
        if (scope === 'all') {
            dictValues.forEach((item) => {
                addDictionary(item);
            });
        } else if (scope === 'tib') {
            dictValues.forEach((item) => {
                if (engDicts.includes(item)) {
                    removeDictionary(item);
                } else {
                    addDictionary(item);
                }
            });
        } else if (scope === 'eng') {
            dictValues.forEach((item) => {
                if (engDicts.includes(item)) {
                    addDictionary(item);
                } else {
                    removeDictionary(item);
                }
            });
        } else if (scope === 'none') {
            dictValues.forEach((item) => {
                removeDictionary(item);
            });
        }
    };

    // select the new dictionaries
    const selectNewarDicts = (dtype, scope) => {
        const dictsel = `#${dtype} input.dictionary`;
        // console.log("dictsel", dictsel);
        const dictValues = Array.from(document.querySelectorAll(dictsel)).map(
            (input) => input.value
        );
        // console.log("dict values", dictValues);
        if (scope === 'all') {
            dictValues.forEach((item) => {
                addDictionary(item);
            });
        } else {
            dictValues.forEach((item) => {
                removeDictionary(item);
            });
        }
    };

    useEffect(() => {
        const seldictcookie = localStorage.getItem('selectedDictionaries');
        if (seldictcookie) {
            setSelectedDicts(seldictcookie);
        }
    }, []);

    // On load of dict info, show the dictionaries for the chosen language if not already set.
    // Set selected based on cookie
    useEffect(() => {
        //console.log('Dict info changed', dictInfo);
        const seldicts = localStorage.getItem('selectedDictionaries');
        const langdicts = getDictsByLang(lang);
        for (const dkey in langdicts) {
            const selval = !seldicts || seldicts.includes(dkey);
            langdicts[dkey].selected = selval;
        }
        setDictionaries(langdicts);
        localStorage.setItem('selectedDictionaries', langdicts);
    }, [dictInfo]);

    // When ever dictionaries object changes, something de/selected, save cookie
    useEffect(() => {
        let seldicts = getSelectedDicts(lang);
        localStorage.setItem('selectedDictionaries', seldicts);
    }, [dictionaries]);

    const showdicts = Object.values(dictionaries);

    const modNewInd = showdicts.findIndex((dict) => dict.code === 'mali');
    const classNewDicts =
        modNewInd > 0 ? showdicts.slice(0, modNewInd) : showdicts;
    const modNewDicts = modNewInd > 0 ? showdicts.slice(modNewInd) : [];

    let dictcontent =
        lang === 'bod' ? (
            <>
                <div style={{ flex: 1 }}>
                    {showdicts
                        .slice(0, Math.ceil(showdicts.length / 2))
                        .map((dict, index) => (
                            <DictItem dict={dict} key={index} />
                        ))}
                </div>
                <div style={{ flex: 1 }}>
                    {showdicts
                        .slice(Math.ceil(showdicts.length / 2))
                        .map((dict, index) => (
                            <DictItem
                                dict={dict}
                                key={index + Math.ceil(showdicts.length / 2)}
                            />
                        ))}
                </div>
            </>
        ) : (
            <div>
                <div id="classical-dicts">
                    <h4 className="font-weight-bold text-left">
                        Classical Newar{' '}
                        <span className="font-weight-normal">
                            (
                            <a
                                onClick={(e) =>
                                    selectNewarDicts('classical-dicts', 'all')
                                }
                            >
                                all
                            </a>
                            {' | '}
                            <a
                                onClick={(e) =>
                                    selectNewarDicts('classical-dicts', 'none')
                                }
                            >
                                none
                            </a>
                            )
                        </span>
                    </h4>
                    {classNewDicts.map((dict, index) => (
                        <DictItem dict={dict} key={index} />
                    ))}
                </div>
                <div id="modern-dicts">
                    <h4 className="mt-3 font-weight-bold text-left">
                        Modern Newar{' '}
                        <span className="font-weight-normal">
                            (
                            <a
                                onClick={(e) =>
                                    selectNewarDicts('modern-dicts', 'all')
                                }
                            >
                                all
                            </a>
                            {' | '}
                            <a
                                onClick={(e) =>
                                    selectNewarDicts('modern-dicts', 'none')
                                }
                            >
                                none
                            </a>
                            )
                        </span>
                    </h4>
                    {modNewDicts.map((dict, index) => (
                        <DictItem dict={dict} key={index} />
                    ))}
                </div>
            </div>
        );
    return (
        <div id="dictionary-list">
            {lang === 'bod' && (
                <div id="dict-links" className="text-center">
                    (<a onClick={() => selectDicts('all')}>All</a> |{' '}
                    <a onClick={() => selectDicts('tib')}>Tib Only</a> |{' '}
                    <a onClick={() => selectDicts('eng')}>Eng Only</a> |{' '}
                    <a onClick={() => selectDicts('none')}>None</a>)
                </div>
            )}
            <form id="dictionary-form" style={{ display: 'flex', gap: '20px' }}>
                {dictcontent}
            </form>
        </div>
    );
}

function DictItem({ dict }) {
    const { dictInfo, dictionaries, addDictionary, removeDictionary } =
        useDictionaryStore();
    const dinfo = dictInfo[dict.code];
    const dictsrcs = getDictSources();

    // console.log('dinfo', dinfo);
    if (!dinfo || !dinfo?.title) {
        return null;
    }
    const handleCheckboxChange = (event) => {
        const code = event.target.value;
        const sel = dictionaries[code]?.selected;
        if (sel) {
            removeDictionary(code);
        } else {
            addDictionary(code);
        }
    };

    const biblicon = process.env.REACT_APP_DICT_SOURCES.includes(dict.code) ? (
        <TermDictionarySource srcid={dictsrcs[dict.code]} dict={dict} />
    ) : null;

    //return <li>{dinfo.title}</li>;
    return (
        <div className="form-check" key={dict.code}>
            <input
                className="form-check-input dictionary"
                type="checkbox"
                value={dict.code}
                id={`checkbox-${dict.code}`}
                onChange={handleCheckboxChange}
                checked={dictionaries[dict.code]?.selected}
            />
            <label
                className="form-check-label d-inline-block ml-3"
                htmlFor={`checkbox-${dict.code}`}
            >
                {dictTitleFix(dinfo.title)} {biblicon}
            </label>
        </div>
    );
}

/**
 * Function to fix titles displayed in dictionary chooser when API data needs to be modified.
 * Used for NOD right now
 *
 * @param dtitle
 * @returns {*}
 */
export function dictTitleFix(dtitle) {
    const replacements = {
        ', Śreṣṭhācārya': '', // remove middle name before 'et al.'
        Pradhan: 'Pradhān', // Use diacritic spelling
        Malla: 'Malla et al.',
    };
    Object.keys(replacements).forEach((key) => {
        dtitle = dtitle.replace(key, replacements[key]);
    });
    return dtitle;
}

export function TermDictionarySource({ srcid, dict }) {
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const [copied, setCopied] = useState(false);

    const sourceCopy = (e) => {
        e.preventDefault();
        // Use data-src to find target div to copy
        const srcelid = e.currentTarget.dataset.src + '-citation';
        const target = document.getElementById(srcelid);
        // Create a range and select the div's contents
        const range = document.createRange();
        range.selectNodeContents(target);

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);

        try {
            // Execute the copy command
            const successful = document.execCommand('copy');
            if (successful) {
                setCopied(true);
                setTimeout(() => setCopied(false), 1500);
            } else {
                console.error('Copy command was unsuccessful');
            }
        } catch (err) {
            console.error('Copy failed', err);
        }

        // Remove selection
        selection.removeAllRanges();
    };

    return (
        <>
            {' '}
            <div
                className="d-inline-block font-100"
                style={{ verticalAlign: 'super' }}
            >
                <a
                    href="#"
                    ref={target}
                    onClick={(e) => {
                        e.preventDefault();
                        setShow(!show);
                    }}
                    className="dict-source-link font-85"
                    title="Click to view citation"
                >
                    <BsBlockquoteLeft />
                </a>
            </div>
            <Overlay
                target={target.current}
                show={show}
                placement="right"
                rootClose
                onHide={() => setShow(false)}
            >
                {({ placement, arrowProps, show: _show, popper, ...props }) => (
                    <Popover id={`dict-popover-${srcid}`} {...props}>
                        <Popover.Title as="h3">
                            Dictionary Citation
                            <span className="d-inline-block float-right">
                                <span
                                    className={
                                        copied
                                            ? 'd-inline-block text-danger h5'
                                            : 'd-none'
                                    }
                                >
                                    Copied!{' '}
                                </span>{' '}
                                <a
                                    className="copyref"
                                    data-src={srcid}
                                    onClick={sourceCopy}
                                    title="Copy citation to clipboard"
                                >
                                    <FaRegClipboard />
                                </a>{' '}
                                <a
                                    href={
                                        process.env.REACT_APP_DRUPAL_SOURCES +
                                        '/node/' +
                                        srcid
                                    }
                                    target="_blank"
                                    title="View source record in Mandala"
                                >
                                    <FaExternalLinkAlt />
                                </a>
                            </span>
                        </Popover.Title>
                        <Popover.Content>
                            <DictionarySource srcid={srcid} />
                        </Popover.Content>
                    </Popover>
                )}
            </Overlay>
        </>
    );
}

function DictionarySource({ srcid }) {
    const [citation, setCitation] = useState('Loading ...');
    const srcapi =
        process.env.REACT_APP_DRUPAL_SOURCES +
        process.env.REACT_APP_DRUPAL_SOURCES_API.replace('__NID__', srcid);
    /*
    REACT_APP_DRUPAL_SOURCES=https://sources.mandala.library.virginia.edu
REACT_APP_DRUPAL_SOURCES_API=/sources-api/json/__NID__
     */
    useEffect(() => {
        axios
            .get(srcapi)
            .then((response) => {
                const citrect = response.data;
                let authors = citrect.biblio_contributors
                    .filter((arec) => arec.auth_type * 1 === 1)
                    .map((arec) => {
                        return arec.name;
                    });
                switch (authors.length) {
                    case 1:
                        authors = authors[0];
                        break;
                    case 2:
                        authors = authors.join(' &amp; ');
                        break;
                    default:
                        const lasta = authors.pop();
                        if (lasta === 'et al') {
                            authors = authors.join(', ') + ' et al.';
                        } else {
                            authors = authors.join(', ') + ' &amp; ' + lasta;
                        }
                }
                if (authors[authors.length - 1] !== '.') {
                    authors += '.';
                }
                let editors = citrect.biblio_contributors
                    .filter((arec) => arec.auth_type * 1 === 14)
                    .map((arec) => {
                        return arec.name;
                    });
                if (editors.length > 0) {
                    editors = ', edited by ' + editors.join(', ');
                } else {
                    editors = '';
                }
                let reprint =
                    citrect?.biblio_reprint_edition?.length > 0
                        ? ` ${citrect.biblio_reprint_edition}`
                        : '';
                const byear =
                    citrect.biblio_year === '0' ? '' : `${citrect.biblio_year}`;
                const pubinfo =
                    citrect.biblio_publisher === ''
                        ? ''
                        : `${citrect.biblio_place_published}: ${citrect.biblio_publisher}`;

                if (pubinfo !== '' && reprint !== '') {
                    reprint = ` (${reprint.trim()})`;
                }
                const newcitation = `<p>${authors} <em>${citrect.title}</em>${editors}. 
                            ${pubinfo}${reprint}, ${byear}.</p>`;
                setCitation(newcitation);
            })
            .catch((error) => {
                console.log('error', error);
            });
    }, [srcid]);

    return (
        <div id={`${srcid}-citation`} className="dict-citation">
            <HtmlCustom markup={citation} />
        </div>
    );
}
